export default "__VITE_ASSET__012c5cb5__"